import { useContext } from 'react';
import type { FunctionComponent } from 'react';

import { Avatar, useTheme } from '@pega/cosmos-react-core';
import type { AvatarProps } from '@pega/cosmos-react-core';

import type { SubComponentVariant } from '../Feed/Feed.types';
import { FeedContext } from '../Feed/Feed.context';

interface AutopilotAvatarProps {
  variant?: SubComponentVariant['variant'];
}

const AutopilotAvatar: FunctionComponent<AutopilotAvatarProps> = ({ variant }) => {
  const {
    autopilotInfo: { label: autopilotLabel }
  } = useContext(FeedContext);
  const theme = useTheme();

  let size: AvatarProps['size'] = 'm';
  if (variant === 'post') size = 'l';

  return (
    <Avatar
      name={autopilotLabel}
      icon='polaris-solid'
      size={size}
      color={theme.base.palette.light}
      backgroundColor={theme.base.palette.ai}
    />
  );
};

export default AutopilotAvatar;
